let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("92UY8")).then(() => parcelRequire('amj3p'));